<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.EDIT') }} {{ $t('APP_CONTENT.APP_CONTENT') }}
          </span>
        </v-toolbar-title>

        <v-spacer />

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>

      <v-divider />
    </v-card>

    <v-card v-if="error" tile class="mt-5">
      <v-alert
        v-for="(e, index) in error.data.errors"
        :key="index"
        tile
        color="error"
        dark
        dense
      >
        {{ e[0] }}
      </v-alert>
    </v-card>

    <v-card v-if="Object.keys(localappcontent).length" tile class="pa-5 mt-4">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="localappcontent.title"
              :rules="rules.requiredTextLine65"
              :counter="65"
              outlined
              :label="`${$t('ITEM.TITLE')} *`"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-content-tabs
              v-if="Object.keys(localappcontent).length"
              v-model="localappcontent"
              form-path="modules/app_content/components/AppContentIframeForm.vue"
            />
          </v-col>
        </v-row>

        <v-row class="pr-4">
          <v-spacer />

          <v-btn
            type="submit"
            :disabled="!valid"
            elevation="24"
            large
            color="success"
          >
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-row>
      </v-form>
    </v-card>

    <apps-list class="mt-5" :apps="apps.data" :meta="meta" @refresh="getApps" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from 'lodash';
import { requiredTextLine65 } from '@/modules/_global/variables/rules.js';
import AppsList from '@/modules/apps/components/AppsList';
import { LINK } from '@/modules/app_content/common/content-types';

export default {
  name: 'AppContentEditPage',

  components: {
    AppsList,
    AppContentTabs: () =>
      import('@/modules/app_content/components/AppContentTranslationTabs.vue')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      rules: {
        requiredTextLine65
      },
      error: null,
      valid: true,
      localappcontent: {},
      copyLocalappcontent: null,
      categories: [],
      apps: [],
      meta: {}
    };
  },

  created() {
    this.setData();
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),
    ...mapActions('appcontent', ['retrieveLink', 'updateLink']),
    ...mapActions('appcontent', ['retrieveAppsByContentId']),

    validate() {
      if (this.$refs.form.validate()) {
        this.updateLink(this.localappcontent)
          .then(({ data }) => {
            this.setSnack({
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });

            this.$emit('success', data);
            this.$router.push({ name: 'appcontent' });
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    },

    setData() {
      this.retrieveLink(this.id)
        .then(({ data }) => {
          this.appcontent = data.data;
          this.localappcontent = cloneDeep(this.appcontent);
          this.copyLocalappcontent = cloneDeep(this.appcontent);
        })
        .catch(error => {
          console.log('error');
          this.error = error.response;
        });
    },

    getApps(payload) {
      payload.params.content_id = this.id;
      payload.params.content_type = LINK;

      this.retrieveAppsByContentId(payload).then(data => {
        this.apps = data.data;
        this.meta = data.meta;
      });
    }
  }
};
</script>
